import { Static, String, Object, Number, Boolean } from '@sinclair/typebox';

export type Coupon = Static<typeof Coupon>;
export const Coupon = Object({
  couponNumber: String(),
  code: String(),
  expiryDate: String(),
  type: String(),
  name: String(),
  applied: Boolean(),
  useQuantity: Number(),
});
